import { InputGroup as ChakraInputGroup } from '@chakra-ui/react';

export const InputGroup = ChakraInputGroup;
